import { Component, OnInit, Output, EventEmitter, Input } from '@angular/core';
import { FormGroup, FormBuilder, Validators } from '@angular/forms';
import { SelectEvent, FileInfo, RemoveEvent, FileRestrictions } from '@progress/kendo-angular-upload';
import { CollectionDocument } from '../../../shared/interfaces/entities/collection-document.interface';
import { faSave } from '@fortawesome/free-solid-svg-icons';
import { AuthenticationService } from '../../../core/services/authentication.serivce';

@Component({
    selector: 'app-collection-document',
    templateUrl: './collection-document.component.html',
    styleUrl: './collection-document.component.css',
    standalone: false
})
export class CollectionDocumentComponent implements OnInit {

  @Input() entity: CollectionDocument;
  @Output() submitForm: EventEmitter<FormData> = new EventEmitter();

  file: FileInfo;
  isNew: boolean = false;
  form: FormGroup;

  saveIcon = faSave;
  saving: boolean = false;

  myRestrictions: FileRestrictions = {
    allowedExtensions: [".jpg", ".png"],
  };

  constructor(private fb: FormBuilder, private auth: AuthenticationService) { }

  ngOnInit() {
    this.isNew = this.entity.id == undefined || this.entity.id == null || this.entity.id == 0;

    if (this.isNew) {
      this.entity.id = 0;
      var collectionId = Number(window.location.pathname.split('/').at(-1));
      this.entity.collectionId = collectionId;
    }

    this.form = this.fb.group({
      id: [this.entity.id],
      collectionId: [this.entity.collectionId],
      name: [this.entity.name, Validators.required],
      description: [this.entity.description],
      file: [this.entity.file],
      organizationId: [this.entity.organizationId]
    });
  }

  onSelect(ev: SelectEvent) {
    if (ev.files) {
      ev.files.forEach((file: FileInfo) => {
        if (file.rawFile && !file.validationErrors) {
          this.file = file;
        }
      });
    }
  }

  save() {
    var organizationId = this.auth.getOrganizationId();

    this.form.controls['file'].setValue(this.file);
    this.form.controls['organizationId'].setValue(organizationId);

    var formData = new FormData();
    for (var key in this.form.value) {
      formData.append(key, this.form.value[key]);
    }

    //if (this.isNew) {
    formData.append('file', this.file.rawFile as Blob);
 /*   }*/
    this.saving = true;

    this.submitForm.emit(formData);
  }

}
